import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Appareil } from 'src/app/domain/Qualif/appareil';
import { EMarqueAppareilAir } from 'src/app/domain/Qualif/enums/marque-appareil-air';
import { EMarqueAppareilSurface } from 'src/app/domain/Qualif/enums/marque-appareil-surface';
import { EMarqueCompteur } from 'src/app/domain/Qualif/enums/marque-compteur';
import { EMarqueMultimetre } from 'src/app/domain/Qualif/enums/marque-multimetre';
import { EModeleAppareilAir } from 'src/app/domain/Qualif/enums/modele-appareil-air';
import { EModeleAppareilSurface } from 'src/app/domain/Qualif/enums/modele-appareil-surface';
import { EModeleCompteur } from 'src/app/domain/Qualif/enums/modele-compteur';
import { EModeleMultimetre } from 'src/app/domain/Qualif/enums/modele-multimetre';
import { ETypeAppareil } from 'src/app/domain/Qualif/enums/type-appareil';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { StringConverter } from '../string-converter';
import { EAirQFType } from 'src/app/domain/Qualif/enums/air-qf-type';
import { SimpleListModel } from 'src/app/models/simple-list-model';

@Component({
    selector: 'app-appareil-box',
    templateUrl: './appareil-box.html',
    styleUrl: './appareil-box.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, FormsModule, MatOptionModule, MatInputModule, MatDatepickerModule, MatButtonModule, PreventDoubleClickDirective]
})
export class AppareilBoxDialog implements OnInit, AfterContentInit {
    public MarqueCompteurList: string[] = Object.values(EMarqueCompteur)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMarqueCompteurLabel(x));

    public ModeleCompteurList: string[] = Object.values(EModeleCompteur)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getModeleCompteurLabel(x));

    public MarqueMultimetreList: string[] = Object.values(EMarqueMultimetre)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMarqueMultimetreLabel(x));

    public ModeleMultimetreList: string[] = Object.values(EModeleMultimetre)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getModeleMultimetreLabel(x));

    public MarqueAppareilSurfaceList: string[] = Object.values(EMarqueAppareilSurface)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMarqueAppareilSurfaceLabel(x));

    public ModeleAppareilSurfaceList: string[] = Object.values(EModeleAppareilSurface)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getModeleAppareilSurfaceLabel(x));

    public MarqueAppareilAirList: string[] = Object.values(EMarqueAppareilAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMarqueAppareilAirLabel(x));

    public ModeleAppareilAirList: string[] = Object.values(EModeleAppareilAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getModeleAppareilAirLabel(x));

    public TypeAppareilList: SimpleListModel[] = Object.values(ETypeAppareil)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => {
            // const slm = new SimpleListModel();
            // slm.idx = x as number;
            // slm.s = StringConverter.getTypeAppareilLabel(x)
            // return slm;
            return new SimpleListModel({ idx: x, s: StringConverter.getTypeAppareilLabel(x) });
        });
    public MarqueAppareilList: string[] = []
    public ModeleAppareilList: string[] = []

    public Model: Appareil = new Appareil();

    interventionCode: string = '';

    alreadyPickedType: Appareil[] = [];

    constructor(
        public dialogRef: MatDialogRef<AppareilBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.Model = Object.assign({}, data.appareil)
            this.alreadyPickedType = data.alreadyPicked
        }

    }

    ngOnInit() { }

    async ngAfterContentInit(): Promise<void> {
        if (this.alreadyPickedType.length > 0) {
            this.TypeAppareilList = Object.values(ETypeAppareil)
                .filter(x => !isNaN(Number(x)) && !this.alreadyPickedType.map(y => y.Type).includes(x as any))
                .map((x: any) => {
                    // const slm = new SimpleListModel();
                    // slm.idx = x as number;
                    // slm.s = StringConverter.getTypeAppareilLabel(x)
                    // return slm;
                    return new SimpleListModel({ idx: x, s: StringConverter.getTypeAppareilLabel(x) });
                });
        }
        this.getAvailableBrandAndModel();
    }

    getAvailableBrandAndModel() {

        switch (this.Model.Type) {
            case ETypeAppareil.Biocollecteur:
            case ETypeAppareil.Biocollecteur2:
                this.MarqueAppareilList = this.MarqueAppareilAirList
                this.ModeleAppareilList = this.ModeleAppareilAirList
                break;
            case ETypeAppareil.ApplicateurContact:
                this.MarqueAppareilList = this.MarqueAppareilSurfaceList
                this.ModeleAppareilList = this.ModeleAppareilSurfaceList
                break;
            case ETypeAppareil.Compteur:
                this.MarqueAppareilList = this.MarqueCompteurList
                this.ModeleAppareilList = this.ModeleCompteurList
                break;
            case ETypeAppareil.Multimetre:
                this.MarqueAppareilList = this.MarqueMultimetreList
                this.ModeleAppareilList = this.ModeleMultimetreList
                break;
        }
    }
    canSave() {
        return this.Model.NumeroInterne && this.Model.Modele && this.Model.Marque
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
